export var PREFERRED_CHANNELS;
(function (PREFERRED_CHANNELS) {
    PREFERRED_CHANNELS["VIDEO"] = "VIDEO";
    PREFERRED_CHANNELS["PHONE"] = "PHONE";
    PREFERRED_CHANNELS["OFFLINE"] = "OFFLINE";
})(PREFERRED_CHANNELS || (PREFERRED_CHANNELS = {}));
